export default function getRotateAnimation (element, settings) {
    const rotation = {
        //Change de rotation based on the direction
        rotation: `${settings.rotation}deg`
    };


    if( settings.transformOrigin ){
        //"left top | 50% 50%"
        rotation.transformOrigin = settings.transformOrigin;
    }

    rotation.fadefirst = true;

    return rotation;
}

